<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import { ref } from "vue";
import { useAggregatorMethodStore } from "@/store/aggregatorMethodStore";
import { useMethodStore } from "@/store/methodStore";
import { useAgentAccountStore } from "@/store/agentAccountStore";
import { useAggregatorStore } from "@/store/aggregatorStore";
import { useWalletStore } from "@/store/walletStore";
import Swal from "sweetalert2";

/**
 * Dashboard Component
 */
export default {
  setup() {
    const doesAddOpen = ref(false);
    const doesEditOpen = ref(false);
    const doesDeleteOpen = ref(false);
    const doesLoadingOpen = ref(false);
    const aggregatorMethodStore = useAggregatorMethodStore();
    const methodStore = useMethodStore();
    const agentAccountStore = useAgentAccountStore();
    const aggregatorStore = useAggregatorStore();
    const walletStore = useWalletStore();

    return {
      doesAddOpen,
      doesEditOpen,
      doesDeleteOpen,
      doesLoadingOpen,
      aggregatorMethodStore,
      methodStore,
      agentAccountStore,
      aggregatorStore,
      walletStore,
    };
  },
  page: {
    title: "aggregator_method",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "aggregators methods",
      items: [
        {
          text: "Menu",
        },
        {
          text: "aggregators methods",
          active: true,
        },
      ],
      errors: [],
      aggregator_method: {},
      aggregator_methods: [],
      aggregator_methods_search: [],
      methods: [],
      accounts: [],
      aggregators: [],
      wallets: [],
      selectedMethod: null,

      name: "",
      rate: 0,
      status_boolean: "",
      type: "deposit",
      rateType: "percent",
      mode: "",
      url: "",
      min: 0,
      max: 0,
      aggregator_id: "",
      implementation: "",
      method_id: "",
      parent_id: "",
      account_id: "",
      wallet_id: "",
      topics: [],
      newTopic: "",
      country_id: "",
      currency_id: "",

      loading: false,
      status: 201,
      length: 0,
    };
  },
  methods: {
    async loadFromStore() {
      if (!this.aggregatorMethodStore.list) {
        await this.aggregatorMethodStore.loadFromApi(true).then((data) => {
          this.aggregator_methods = data;
          this.aggregator_methods_search = data;
          this.length = this.aggregator_methods.length;
        });
      } else {
        this.aggregator_methods = this.aggregatorMethodStore.list;
        this.aggregator_methods_search = this.aggregator_methods;
        this.length = this.aggregator_methods.length;
      }
    },

  async  deleteIt() {
      await this.aggregatorMethodStore.deleteItem(this.aggregator_method.id);
      this.aggregator_methods = this.aggregatorMethodStore.list
      this.aggregator_methods_search = this.aggregator_methods
    },

    async loadMethods() {
      if (!this.methodStore.list) {
        await this.methodStore.loadFromApi().then((data) => {
          this.methods = data;
        });
      } else {
        this.methods = this.methodStore.list;
      }
    },

    async refresh() {
      await this.aggregatorMethodStore.loadFromApi(true).then((data) => {
        this.aggregator_methods = data;
        this.aggregator_methods_search = data;
        this.length = this.aggregator_methods.length;
      });
    },

    async loadAggregators() {
      if (!this.aggregatorStore.list) {
        await this.aggregatorStore.loadFromApi().then((data) => {
          this.aggregators = data;
        });
      } else {
        this.aggregators = this.aggregatorStore.list;
      }
    },

    async loadAccounts() {
      if (!this.agentAccountStore.list) {
        await this.agentAccountStore.loadFromApi().then((data) => {
          this.accounts = data;
        });
      } else {
        this.accounts = this.agentAccountStore.list;
      }
    },

    async loadWallets() {
      if (!this.walletStore.list) {
        await this.walletStore.loadFromApi().then((data) => {
          this.walletStore = data;
        });
      } else {
        this.wallets = this.walletStore.list;
      }
    },

    addItem() {
      this.errors = [];
      let body = {
        rate: parseFloat(this.rate),
        status: this.status_boolean,
        type: this.type,
        rateType: this.rateType,
        min: parseFloat(this.min),
        max: parseFloat(this.max),
        aggregator: {
          id: this.aggregator_id,
        },
      };

      if (this.account_id && this.account_id != "") {
        body["receiveAccount"] = {
          id: this.account_id,
        };
      }
      if (this.wallet_id && this.wallet_id != "") {
        body["wallet"] = {
          id: this.wallet_id,
        };
      }
      if (this.method_id && this.method_id != "") {
        body["method"] = {
          id: this.method_id,
        };
      }
      if (this.name && this.name != "") {
        body["name"] = this.name;
      }
      if (this.url && this.url != "") {
        body["url"] = this.url;
      }

      if (this.mode !== "") {
        body["mode"] = this.mode;
      }

      if (this.topics && this.topics.length > 0) {
        body["topics"] = this.topics;
      }
      this.aggregatorMethodStore.createItem(body);
      this.aggregator_methods = this.aggregatorMethodStore.list;
      this.aggregator_methods_search = this.aggregator_methods;
    },

    editItem() {
      this.errors = [];
      let body = {
        name: this.name,
        rate: parseFloat(this.rate),
        status: this.status_boolean,
        url: this.url,
        type: this.type,
        rateType: this.rateType,
        mode: this.mode,
        topics: this.topics,
        min: parseFloat(this.min),
        max: parseFloat(this.max),
        aggregator: {
          id: this.aggregator_id,
        },
        method: {
          id: this.method_id,
        },
      };

      if (this.account_id != "") {
        body["receiveAccount"] = {
          id: this.account_id,
        };
      }
      if (this.wallet_id && this.wallet_id != "") {
        
        body["wallet"] = {
          id: this.wallet_id,
        };
      }
      if (this.method_id != "") {
        body["method"] = {
          id: this.method_id,
        };
      }
      if (this.name && this.name != "") {
        body["name"] = this.name;
      }
      if (this.url && this.url != "") {
        body["url"] = this.url;
      }

      if (this.mode !== "") {
        body["mode"] = this.mode;
      }

      if (this.topics && this.topics.length > 0) {
        body["topics"] = this.topics;
      }

      this.aggregatorMethodStore.editItem(this.aggregator_method?.id, body);
      this.aggregator_methods = this.aggregatorMethodStore.list;
      this.aggregator_methods_search = this.aggregator_methods;
    },

    async onAddItem() {
      Swal.showLoading(null);
      await Promise.all([
        this.loadMethods(),
        this.loadAggregators(),
        this.loadAccounts(),
        this.loadWallets(),
      ]);
      this.initData(null);
      Swal.close();
      this.doesAddOpen = true;
    },

    async initItem(aggregator_method, action = "edit") {
      this.aggregator_method = aggregator_method;
      if (action == "delete") {
        this.doesDeleteOpen = true;
      } else {
        Swal.showLoading(null);
        await Promise.all([
          this.loadMethods(),
          this.loadAggregators(),
          this.loadAccounts(),
          this.loadWallets(),
        ]);
        this.initData(aggregator_method);
        Swal.close();
        this.doesEditOpen = true;
      }
    },
    initData(item = null) {
      this.name = item != null ? item.name : "";
      this.implementation = item != null ? item.implementation : "";
      this.rate = item != null ? item.rate : "";
      this.type = item != null ? item.type : "";
      this.status_boolean = item != null ? item.status : "";
      this.url = item != null ? item.url : "";
      this.mode = item != null ? item.mode : "";
      this.rateType = item != null ? item.rateType : "";
      this.privateKey = item != null ? item.privateKey : "";
      this.min = item != null ? item.min : "";
      this.max = item != null ? item.max : "";
      this.aggregator_id = item != null ? item?.idOfAggregator : "";
      (this.method_id = item != null ? item?.idOfMethod : ""),
        (this.wallet_id = item != null ? item?.idOfWallet : "");
      this.parent_id = item != null ? item?.idOfParent : "";
      this.topics = item != null ? item?.topics : [];
      this.account_id = item?.receiveAccount != null ? item?.receiveAccount?.id : "";
      this.selectedMethod = item;
    },

    addTopic() {
      if (this.newTopic.trim() === "") {
        this.errors.topics = "Veuillez entrer un topic.";
        return;
      }

      this.topics ??= [];

      this.topics.push(this.newTopic.trim());
      this.newTopic = ""; // Réinitialiser le champ d'entrée
    },

    // Supprimer un topic de la liste
    removeTopic(index) {
      this.topics.splice(index, 1);
      this.errors.topics = "";
    },

    validateTopic() {
      // Exemple de validation avant soumission
      if (this.topics.length === 0) {
        this.errors.topics = "Veuillez ajouter au moins un topic.";
        return;
      }
      // Votre logique de soumission ici...
    },

    compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },
  },

  mounted() {
    this.loadFromStore();

    this.doesLoadingOpen = false;
  },
  computed: {
    filterWallets() {
      let list = this.wallets;
      if (this.aggregator_id && this.aggregator_id != "") {
        list = list?.filter(
          (ele) => !ele.idOfAggregator || ele.idOfAggregator == this.aggregator_id
        );
      }

      if (this.method_id && this.method_id != "") {
        list = list?.filter((ele) => !ele.idOfMethod || ele.idOfMethod == this.method_id);
      } else if (this.country_id && this.country_id != "") {
        list = list?.filter(
          (ele) => !ele.idOfCountry || ele.idOfCountry == this.country_id
        );
      } else if (this.currency_id && this.currency_id != "") {
        list = list?.filter(
          (ele) => !ele.idOfCurrency || ele.idOfCurrency == this.currency_id
        );
      }

      return list;
    },
  },
  watch: {
    doesAddOpen: function () {
      this.errors = [];
      if (!this.doesAddOpen) {
        this.initData(null);
      }
    },
    doesEditOpen: function () {
      this.errors = [];
      if (!this.doesEditOpen) {
        this.initData(null);
        this.aggregator_method = null;
      }
    },
    doesDeleteOpen: function () {
      if (!this.doesDeleteOpen) {
        this.initData(null);
        this.aggregator_method = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
      <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class="bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
      <b-button variant="primary" @click="onAddItem()" class="ms-1">
        <i class="bx bx-plus font-size-16 align-middle me-2"></i>
        Ajouter un nouveau
      </b-button>
    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des aggregateurs méthodes</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des
              <code>aggregateurs méthodes</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Méthode</th>
                    <th>Aggregateur</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>RateType</th>
                    <th>Mode</th>
                    <th>Min - Max</th>
                    <th>Rate</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(aggregator_method, i) in aggregator_methods"
                    :key="aggregator_method.id"
                  >
                    <th scope="row"  v-on:click="compileToClipboard(aggregator_method.id)"
                      style="cursor: pointer">{{ i + 1 }}</th>
                    <td>
                      {{ aggregator_method?.method?.name }}
                    </td>
                    <td>
                      {{ aggregator_method?.aggregator?.name }}
                    </td>
                    <td>
                      {{ aggregator_method?.type }}
                    </td>
                    <td>
                      {{ aggregator_method?.status ? "Oui" : "Non" }}
                    </td>
                    <td>
                      {{ aggregator_method?.rateType }}
                    </td>
                    <td>
                      {{ aggregator_method?.mode }}
                    </td>
                    <td>
                      {{
                        aggregator_method.min && aggregator_method.max
                          ? parseInt(aggregator_method.min) +
                            " - " +
                            parseInt(aggregator_method.max)
                          : ""
                      }}
                    </td>
                    <td>{{ Number(aggregator_method.rate) }}</td>
                    <td class="hstack">
                      <b-button
                        class="btn-sm ms-2"
                        @click="initItem(aggregator_method, 'edit')"
                        variant="success"
                      >
                        <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <b-button
                        variant="danger"
                        @click="initItem(aggregator_method, 'delete')"
                        class="ms-2 btn-sm"
                      >
                        <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <router-link :to="'/aggregators-methods/' + aggregator_method.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal
      v-model="doesLoadingOpen"
      id="modal-center"
      centered
      size="md"
      title="Chargement..."
      title-class="font-18"
      hide-footer
    >
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
      v-model="doesAddOpen"
      id="modal-center"
      centered
      size="lg"
      title="Ajouter un aggregateur méthode"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="addItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Nom</label>
            <input type="text" v-model="name" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name">{{ errors.name }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Rate</label>
            <input type="text" required v-model="rate" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.rate">{{ errors.rate }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Status </label>
            <select class="form-control" required v-model="status_boolean">
              <option :value="true">Oui</option>
              <option :value="false">Non</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.status">{{ errors.status }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Type</label>
            <select required v-model="type" class="form-control">
              <option value="deposit">Dépôt</option>
              <option value="withdraw">Retrait</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Mode</label>
            <select required v-model="mode" class="form-control">
              <option value="automatic">Automatic</option>
              <option value="manual">Manuel</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">URL</label>
            <input type="text" v-model="url" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.url">{{ errors.url }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Rate Type</label>
            <select required v-model="rateType" class="form-control">
              <option value="percent">Pourcentage</option>
              <option value="interval">Intervalle</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.rateType">{{
              errors.rateType
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Min</label>
            <input type="text" v-model="min" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.min">{{ errors.min }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Max</label>
            <input type="text" v-model="max" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.max">{{ errors.max }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Aggregator</label>
            <select required v-model="aggregator_id" class="form-control">
              <option value=""></option>
              <template v-for="aggregator in aggregators" :key="aggregator.id">
                <option :value="aggregator.id">{{ aggregator.name }}</option>
              </template>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Methode</label>
            <select required v-model="method_id" class="form-control">
              <option value=""></option>
              <template v-for="method in methods" :key="method.id">
                <option :value="method.id">{{ method.name }}</option>
              </template>
            </select>
          </div>
          <!-- <div class="col-md-6 mb-3">
              <label for="">Account</label>
              <select v-model="account_id" class="form-control">
                <option value=""></option>
                <template v-for="account in accounts" :key="account.id">
                  <option :value="account.id">{{ account.accountName }} ({{account.number}}) </option>
                </template>
              </select>
            </div> -->

          <div class="col-md-6 mb-3">
            <label for="">Wallet</label>
            <select v-model="wallet_id" class="form-control">
              <option value=""></option>
              <template v-for="wallet in filterWallets" :key="wallet.id">
                <option :value="wallet.id">
                  {{
                    wallet.accountName ??
                    wallet.method?.name ??
                    wallet.country?.name_en ??
                    wallet.currency?.name_en
                  }}
                  ({{ wallet.number ?? wallet.aggregator?.name }})
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-12 mb-3">
            <label for="">Topics</label>
            <div class="input-group mb-2">
              <input
                type="text"
                v-model="newTopic"
                class="form-control"
                placeholder="Ajouter un topic"
              />
              <button type="button" class="btn btn-secondary" @click="addTopic">
                Ajouter
              </button>
            </div>
            <ul class="list-group">
              <li
                v-for="(topic, index) in topics"
                :key="index"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ topic }}
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  @click="removeTopic(index)"
                >
                  Supprimer
                </button>
              </li>
            </ul>
            <span class="text-danger mt-2" v-if="errors.topics">{{ errors.topics }}</span>
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- EDIT MODAL -->
    <b-modal
      v-model="doesEditOpen"
      id="modal-center"
      centered
      size="lg"
      title="Modifier un aggregateur méthode"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="editItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Nom</label>
            <input type="text" v-model="name" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name">{{ errors.name }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Rate</label>
            <input type="text" required v-model="rate" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.rate">{{ errors.rate }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Status </label>
            <select class="form-control" required v-model="status_boolean">
              <option :value="true">Oui</option>
              <option :value="false">Non</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.status_boolean">{{
              errors.status_boolean
            }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Type</label>
            <select required v-model="type" class="form-control">
              <option value="deposit">Dépôt</option>
              <option value="withdraw">Retrait</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Mode</label>
            <select required v-model="mode" class="form-control">
              <option value="automatic">Automatic</option>
              <option value="manual">Manuel</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.type">{{ errors.type }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">URL</label>
            <input type="text" v-model="url" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.url">{{ errors.url }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Rate Type</label>
            <select required v-model="rateType" class="form-control">
              <option value="percent">Pourcentage</option>
              <option value="interval">Intervalle</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.rateType">{{
              errors.rateType
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Min</label>
            <input type="text" v-model="min" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.min">{{ errors.min }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Max</label>
            <input type="text" v-model="max" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.max">{{ errors.max }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Aggregator</label>
            <select required v-model="aggregator_id" class="form-control">
              <option value=""></option>
              <template v-for="aggregator in aggregators" :key="aggregator.id">
                <option :value="aggregator.id">{{ aggregator.name }}</option>
              </template>
            </select>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Methode</label>
            <select required v-model="method_id" class="form-control">
              <option value=""></option>
              <template v-for="method in methods" :key="method.id">
                <option :value="method.id">{{ method.name }}</option>
              </template>
            </select>
          </div>
          <!-- <div class="col-md-6 mb-3">
              <label for="">Account</label>
              <select v-model="account_id" class="form-control">
                <option value=""></option>
                <template v-for="account in accounts" :key="account.id">
                  <option :value="account.id">{{ account.accountName }} ({{account.number}}) </option>
                </template>
              </select>
            </div> -->

          <div class="col-md-6 mb-3">
            <label for="">Wallet</label>
            <select v-model="wallet_id" class="form-control">
              <option value=""></option>
              <template v-for="wallet in filterWallets" :key="wallet.id">
                <option :value="wallet.id">
                  {{
                    wallet.accountName ??
                    wallet.method?.name ??
                    wallet.country?.name_en ??
                    wallet.currency?.name_en
                  }}
                  ({{ wallet.number ?? wallet.aggregator?.name }})
                </option>
              </template>
            </select>
          </div>

          <div class="col-md-12 mb-3">
            <label for="">Topics</label>
            <div class="input-group mb-2">
              <input
                type="text"
                v-model="newTopic"
                class="form-control"
                placeholder="Ajouter un topic"
              />
              <button type="button" class="btn btn-secondary" @click="addTopic">
                Ajouter
              </button>
            </div>
            <ul class="list-group">
              <li
                v-for="(topic, index) in topics"
                :key="index"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ topic }}
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  @click="removeTopic(index)"
                >
                  Supprimer
                </button>
              </li>
            </ul>
            <span class="text-danger mt-2" v-if="errors.topics">{{ errors.topics }}</span>
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- DELETE MODAL -->
    <b-modal
      v-model="doesDeleteOpen"
      id="modal-center"
      title="Supprimer un échange"
      title-class="font-18"
      hide-footer
    >
      <p class="mb-2">
        Voulez-vous vraiment supprimer l'échange
        <b>{{ aggregator_method?.from?.name }} - {{ aggregator_method?.to?.name }}</b> ?
      </p>
      <div class="hstack mt-2" v-if="!loading">
        <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">
          Annuler
        </button>
        <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
      </div>
      <div class="text-center" v-else>
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
